var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import "@frameworks/salesjourney/stylesheets/components/Features/Downloads/Downloads.scss";
import SearchField from "@frameworks/salesjourney/components/Generic/SearchField";
import { downloadCategory, CurrentView, } from "./downloadConstants";
import { Accordion } from "react-bootstrap";
import DownloadCategory from "./DownloadByCategory";
import { useLocation } from "react-router-dom";
var Downloads = function () {
    var _a;
    var location = useLocation();
    var showToday = (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.showToday;
    var _b = __read(useState(CurrentView), 2), currentView = _b[0], setCurrentView = _b[1];
    var _c = __read(useState(""), 2), searchText = _c[0], setSearchText = _c[1];
    return (React.createElement("div", { className: "downloads-primary-container" },
        React.createElement("div", { className: "DMSan_28_700 txt-midnight-blue mb-2 pb-1" }, "Downloads"),
        React.createElement(SearchField, { searchText: searchText, setSearchText: setSearchText, placeholder: "Search", searchIcon: "", parentClass: "downloads-search-field" }),
        React.createElement("div", { className: "download-by-category pb-1" },
            React.createElement(Accordion, { defaultActiveKey: showToday !== null && showToday !== void 0 ? showToday : "" }, downloadCategory === null || downloadCategory === void 0 ? void 0 : downloadCategory.map(function (category) { return (React.createElement(Accordion.Item, { eventKey: category === null || category === void 0 ? void 0 : category.category, onClick: function (e) {
                    e.stopPropagation();
                } },
                React.createElement(Accordion.Header, { className: "DMSan_14_500" },
                    React.createElement("span", null, category === null || category === void 0 ? void 0 : category.category)),
                React.createElement(Accordion.Body, { onEnter: function () {
                        setCurrentView(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[category.category] = true, _a)));
                        });
                    }, onExited: function () {
                        setCurrentView(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[category.category] = false, _a)));
                        });
                    } },
                    React.createElement(DownloadCategory, { dateCategory: category.category, searchText: searchText, showToday: showToday, openAccd: currentView[category.category] })))); })))));
};
export default Downloads;
